import React, { Component } from 'react';
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/styles";
import {
    downloadFile,
    exportReport,
    fetchFileAsObjectUrl,
    organisationDetails,
    uploadFile
} from "../../util/ApiUtils";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import {SystemUpdateAltTwoTone} from "@material-ui/icons";
import {GreenButton, GreyButton, RedButton} from "../common/ButtonsConstants";
import * as OperationalApiUtils from "../../util/OperationModuleApiUtils";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import * as CommonUtils from "../../util/CommonUtils";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
        padding: '30px',
    },
}));

class OrgChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            orgId: "",
            orgScope: "",
            uploadedFileName: "",
            uploadedFileId: null,
            orgChartPreviewUrl: null,
            organisation: null,
            uploadCalled: false,
        };
        this.export = this.export.bind(this);
        this.showModal = this.showModal.bind(this);
        this.onImageUpload = this.onImageUpload.bind(this);
        this.onFileRemove = this.onFileRemove.bind(this);
        this.fileUploadHandler = this.fileUploadHandler.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
        this._orgChartLoadSeq = 0;
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    componentWillUnmount() {
        this.revokeOrgChartPreview();
    }

    revokeOrgChartPreview() {
        const { orgChartPreviewUrl } = this.state;
        if (orgChartPreviewUrl) {
            URL.revokeObjectURL(orgChartPreviewUrl);
        }
    }

    loadOrganisationDetails() {
        this._orgChartLoadSeq = (this._orgChartLoadSeq || 0) + 1;
        const seq = this._orgChartLoadSeq;
        const previousPreviewUrl = this.state.orgChartPreviewUrl;
        organisationDetails()
            .then(response => {
                if (seq !== this._orgChartLoadSeq) {
                    return;
                }
                console.log(response);
                if (previousPreviewUrl) {
                    URL.revokeObjectURL(previousPreviewUrl);
                }
                this.setState({
                    orgId: response.id,
                    orgScope: response.scope,
                    organisation: response,
                    uploadedFileName: response.orgChartFilename,
                    uploadedFileId: response.uploadedFileId,
                    orgChartPreviewUrl: null,
                    uploadCalled: false,
                }, () => {
                    const fileId = response.uploadedFileId;
                    if (fileId) {
                        fetchFileAsObjectUrl(fileId)
                            .then((url) => {
                                if (seq !== this._orgChartLoadSeq) {
                                    URL.revokeObjectURL(url);
                                    return;
                                }
                                this.setState({ orgChartPreviewUrl: url });
                            })
                            .catch((err) => console.log(err));
                    }
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    showModal() {
        this.setState({ show: true });
    }

    closeModal() {
        this.setState({
            show: false,
        });
    }

    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    export() {
        exportReport('/organisation/export/ORG_CHART');
    }

    onFileRemove() {
        console.log('this.state', this.state)
        OperationalApiUtils.deleteFile('/organisation/deleteFile', this.state.orgId, this.state.uploadedFileId).then(
            () => {
                this.revokeOrgChartPreview();
                this.setState({
                    uploadedFileId: null,
                    uploadedFileName: null,
                    orgChartPreviewUrl: null,
                });
            }
        );
    }

    onImageUpload(event) {
        console.log('event.target.files[0]', event.target.files[0]);
        this.setState({
            uploadedOrgChart: event.target.files[0],
        });
    }

    fileUploadHandler = () => {
        this.setState({
            uploadCalled: true,
        });
        console.log('this.state.uploadedOrgChart', this.state.uploadedOrgChart);
        if (this.state.uploadedOrgChart === undefined) {
            this.setState({
                uploadCalled: false,
            });
            NotificationManager.warning('Error', t('context.orgChart.selectFileError'), 5000);
        } else {
            let filename = this.state.uploadedOrgChart.name;
            console.log('filename', filename);
            let suffix = ".jpg";
            let suffix1 = ".JPG";
            let suffix2 = ".jpeg";
            let suffix3 = ".JPEG";
            let suffix4 = ".png";
            let suffix5 = ".PNG";
            let suffix6 = ".pdf";
            let suffix7 = ".PDF";
            if ((filename.indexOf(suffix, filename.length - suffix.length) === -1)
                && (filename.indexOf(suffix1, filename.length - suffix1.length) === -1)
                && (filename.indexOf(suffix2, filename.length - suffix2.length) === -1)
                && (filename.indexOf(suffix3, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix4, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix5, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix6, filename.length - suffix3.length) === -1)
                && (filename.indexOf(suffix7, filename.length - suffix3.length) === -1)
            ) {
                this.setState({
                    uploadCalled: false,
                });
                NotificationManager.warning('Error', t('context.orgChart.supportedFilesError'), 5000);
            } else {
                const callback = (status, res) => {
                    console.log("fileUploadHandler status " + status);
                    console.log("fileUploadHandler result " + res);
                    NotificationManager.success('Success', t('context.orgChart.uploadSuccess'), 5000);
                    this.setState({
                        selectedFile: null,
                    });
                    this.loadOrganisationDetails();
                };
                uploadFile("/organisation/orgChartUpload", null, this.state.uploadedOrgChart, callback);
            }
        }
    };
    render() {
        const { state } = this;
        const { classes } = this.props;
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <Paper className={classes.root}>
                <Typography component="h2" variant="h5">
                    {t('context.orgChart.title')}
                </Typography>
                <div style={{ marginTop: '30px' }}>
                    {false && <canvas id="imageCanvas"/>}
                    {
                        !state.uploadedFileId
                            ? <span>
                                <label>{t('context.orgChart.uploadPrompt')}</label><input type="file" id="imageLoader" name="imageLoader" onChange={this.onImageUpload}/>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.fileUploadHandler()}
                                    disabled={this.state.uploadCalled || isAuditor || isViewer}
                                >
                                    {t('context.orgChart.uploadButton')}
                                </Button>
                              </span>
                            : <React.Fragment>
                                {state.orgChartPreviewUrl
                                    ? <img src={state.orgChartPreviewUrl} alt="" width="100%"/>
                                    : <span>{t('context.orgChart.loadingPreview')}</span>}
                                <span style={{ textAlign: 'center' }}>
                                    <GreyButton style={{ marginRight: '20px', marginTop: '20px', marginLeft: '20px' }} onClick={() => downloadFile(state.uploadedFileId)}>{t('context.orgChart.download')}</GreyButton>
                                    <RedButton style={{ marginRight: '20px', marginTop: '20px' }} onClick={this.onFileRemove}>{t('context.orgChart.remove')}</RedButton>
                                </span>
                            </React.Fragment>
                    }
                </div>
            </Paper>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(OrgChart);
